import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Radio } from '../models/radio';
import { ConnectionService } from './conexion.service';

@Injectable({
  providedIn: 'root',
})
export class RadioService {
  collection: string = 'radio';
  private data: Promise<Radio[]> = null;

  constructor(private connectionServ: ConnectionService) {
    this.data = this.connectionServ.read2<Radio>(this.collection);
  }

  getVisible() {
    return this.data;
  }

  getById(id: string) {
    return this.data.then((elements) => {
      return elements.find((element) => element.id == id);
    });
  }
}
